export function throwIfNull<T>(argument?: T | null, message = 'Unexpected value <null> encountered!'): T | undefined {
   if (argument === null) {
      throw new TypeError(message);
   }
   return argument;
}

export function throwIfUndefined<T>(
   argument?: T | null,
   message = 'Unexpected value <undefined> encountered!'
): T | null {
   if (argument === undefined) {
      throw new TypeError(message);
   }
   return argument;
}

export function throwIfNullOrUndefined<T>(
   argument?: T | null,
   message = 'Unexpected value <null/undefined> encountered!'
): T {
   if (argument === undefined || argument === null) {
      throw new TypeError(message);
   }
   return argument;
}
